import axios from 'axios'
import _ from 'lodash'
import Errors from './hh-errors.js'

class Form {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   * @param api
   */
  constructor(data, api) {
    this.originalData = _.cloneDeep(data)
    this.$api = api

    for (let field in data) {
      this[field] = data[field]
    }

    this.errors = new Errors()
    this.loading = false
    this.successful = false
    this.statusMessage = ''
    this.response = null
  }


  /**
   * Fetch all relevant data for the form.
   */
  data() {
    let data = {};

    for (let property in this.originalData) {
      data[property] = this[property];
    }

    return data;
  }

  record(data) {
    for (let field in data) {
      this[field] = data[field]
    }
  }


  /**
   * Reset the form fields.
   */
  reset(clearErrors = true) {
    for (let field in this.originalData) {
      this[field] = _.cloneDeep(this.originalData[field])
    }

    if(clearErrors) {
      this.errors.clear()
    }
  }

  startProcessing(){
    this.loading = true
    this.successful = false
  }

  finishProcessing(status = true) {
    this.loading = false
    this.successful = status
  }


  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   */
  post(url) {
    return this.submit('post', url);
  }


  /**
   * Send a PUT request to the given URL.
   * .
   * @param {string} url
   */
  put(url) {
    return this.submit('put', url);
  }


  /**
   * Send a PATCH request to the given URL.
   * .
   * @param {string} url
   */
  patch(url) {
    return this.submit('patch', url);
  }


  /**
   * Send a DELETE request to the given URL.
   * .
   * @param {string} url
   */
  delete(url) {
    return this.submit('delete', url);
  }


  /**
   * Submit the form.
   *
   * @param {string} requestType
   * @param {string} url
   * @param withFiles
   */
  submit(requestType, url, withFiles = false) {
    this.startProcessing()

    let config = null
    let data = this.data()

    if (withFiles) {
      config = {
        header : {
          'Content-Type' : 'multipart/form-data'
        }
      }

      let formData = new FormData();

      for (let property in data) {
        if (data[property] != null) {
          formData.append(property, data[property])
        }
      }

      data = formData
    }

    return this.$api[requestType](url, data, config)
      .then(response => {
        this.onSuccess(response.data);
      })
      .catch(error => {
        let errors = {}

        if (error.response.data.hasOwnProperty('errors')) {
          errors = error.response.data.errors
        }

        this.onFail(errors);
      });
  }

  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   */
  onSuccess(data) {
    // this.reset()
    this.errors.clear()
    this.finishProcessing()
    this.response = data
  }


  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors) {
    if (_.isEmpty(errors) || this.deepCheckOriginalData(errors)) {
      errors.internalError = true
    }

    this.errors.record(errors);
    this.finishProcessing(false)
  }

  /*
  * Set the validation errors
  */
  setErrors(errors){
    this.loading = false

    this.errors.set(errors)
  }

  deepCheckOriginalData(errors) {
    let flattedData = {...this.originalData}

    for (let field in this.originalData) {
      let item = this.originalData[field]
      if (typeof item === 'object' && item !== null && Object.keys(item).length) {
        flattedData = {...flattedData, ...item}
      }
    }

    return _.difference(_.keys(errors), _.keys(flattedData)).length !== 0;
  }
}

export default Form;